<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    title="Staff Position"
    hide-footer
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Staff Position</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <BForm>
      <div class="form-group">
        <BFormInput
          type="text"
          v-model="staffPositionForm.name"
          placeholder="Name"
        ></BFormInput>
      </div>
      <div class="form-group">
        <BFormTextarea
          type="text"
          v-model="staffPositionForm.description"
          placeholder="Description"
        ></BFormTextarea>
      </div>
    </BForm>

    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="handleAction" class="mr-2">{{
          staffPositionData && staffPositionData.uuid ? "Update" : "Save"
        }}</BButton>
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  />
</template>

<script>
import {
  BModal,
  BFormInput,
  BButton,
  BForm,
  BFormTextarea,
} from "bootstrap-vue-next";
import { ref, inject, watch } from "vue";
import ToastResponse from "@/components/ToastResponse.vue";

export default {
  components: {
    BModal,
    BFormInput,
    BButton,
    BForm,
    BFormTextarea,
    ToastResponse,
  },
  props: {
    modal: Boolean,
    staffPositionData: Object,
  },
  emits: ["update:modal"],
  setup(props, { emit }) {
    const repositories = inject("repositories");
    const staffPositionRepository = repositories
      ? repositories.staffPosition
      : null;

    const staffPositionForm = ref({
      name: "",
      description: "",
    });

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    const handleAction = () => {
      props.staffPositionData.uuid ? update() : create();
    };

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const create = async () => {
      await staffPositionRepository
        .create(staffPositionForm.value)
        .then(() => {
          updateModal(false);
          staffPositionForm.value = {};

          modalResponse.value = {
            toast: true,
            text: "Staff created successfully",
            success: true,
          };
          emit("addOrUpdate");
        })
        .catch((err) => {
          console.error(err);
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.error,
            toast: true,
          });
        });
    };

    const update = async () => {
      await staffPositionRepository
        .update(staffPositionForm.value, props.staffPositionData.uuid)
        .then(() => {
          updateModal(false);
          staffPositionForm.value = {};

          modalResponse.value = {
            toast: true,
            text: "Staff updated successfully",
            success: true,
          };
          emit("addOrUpdate");
        })
        .catch((err) => {
          console.error(err);
          Object.assign(modalResponse.value, {
            toast: true,
            text: err.response.data.error,
            success: false,
          });
        });
    };

    watch(
      () => props.staffPositionData,
      (newData) => {
        if (newData) {
          staffPositionForm.value = { ...newData };
        }
      },
      { immediate: true }
    );

    return {
      staffPositionForm,
      updateModal,
      handleAction,
      modalResponse,
      create,
      update,
    };
  },
};
</script>
